/**
 * kavalio custom product scripts (Gallery, Pricing, PDP Badges)
 */

// Gift card variable amount picker — fast DOM update (no section rerender)
(function () {
  function getGiftCardForm() {
    var id = window.giftCardFormId;
    if (!id) return null;
    return document.getElementById(id) || document.forms[id] || null;
  }

  function applyGiftCardVariant(variant) {
    var form = getGiftCardForm();

    // Update hidden variant-id input so add-to-cart submits the right variant
    if (form) {
      var idInput = form.elements && form.elements.namedItem('id');
      if (idInput) idInput.value = variant.id;
    }

    // Update price text (preserve the visually-hidden accessibility span)
    var priceEl = document.querySelector('.product-meta__price-list-container .ed-price-list-inner .price');
    if (priceEl) {
      var vhSpan = priceEl.querySelector('.visually-hidden');
      priceEl.textContent = variant.price;
      if (vhSpan) priceEl.insertBefore(vhSpan, priceEl.firstChild);
    }

    // Update SKU
    var skuEl = document.querySelector('.product-meta__sku-number');
    if (skuEl) skuEl.textContent = variant.sku || '';

    // Update add-to-cart button availability
    if (form) {
      var fid = CSS.escape(form.id);
      var btnSel = '#AddToCart[data-product-add-to-cart-button]';
      document.querySelectorAll(btnSel).forEach(function (btn) {
        console.log(btn);
        if (variant.available) {
          btn.disabled = false;
          btn.removeAttribute('disabled');
          btn.classList.remove('button--ternary');
          btn.querySelector('.loader-button__text').innerText = 'Jetzt in den Warenkorb legen';
          btn.setAttribute('style', '--button-background: var(--primary-button-background);--button-text-color: var(--primary-button-text-color);')
        } else {
          btn.disabled = true;
          btn.setAttribute('disabled', 'disabled');
          btn.classList.add('button--ternary');
          btn.querySelector('.loader-button__text').innerText = 'Ausverkauft';
          btn.setAttribute('style', '--button-background: var(--secondary-background);--button-text-color: var(--root-text-color);')
        }
      });
    }

    // Update URL
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    } catch (err) {}
  }

  // Capture-phase interceptor: fires before the theme's <variant-picker> preload delegate
  // (attached on document.body). The theme preloads a full server-side section re-render on
  // pointerenter/touchstart of any swatch label (theme.js onOptionPreload_fn). For a gift card
  // with hundreds/thousands of variants that render is huge and slow, and on mobile the repeated
  // fetches stall/crash the page. We drive everything client-side via giftCardVariantMap, so kill
  // the preload before it reaches document.body.
  ['pointerenter', 'touchstart'].forEach(function (evtName) {
    document.addEventListener(evtName, function (e) {
      var el = e.target;
      if (!el || !el.closest) return;
      if (!el.closest('[has-gift-card-fixed-values]')) return;
      e.stopPropagation();
    }, true); // true = capture phase, runs before document.body's delegate
  });

  // Capture-phase interceptor: fires before theme's delegate on document.body
  // Handles ALL block-swatch radio changes when has-gift-card-fixed-values is present
  document.addEventListener('change', function (e) {
    if (!e.target.matches('.block-swatch__radio')) return;
    var container = e.target.closest('[has-gift-card-fixed-values]');
    if (!container) return;

    // Stop event before it reaches document.body's delegate → no selectCombination/fetch
    e.stopPropagation();

    var parent = e.target.closest('.block-swatch');
    var isHidden = parent && parent.hasAttribute('hidden');

    // Clear custom input when a visible preset is clicked
    var customInput = container.querySelector('#variable-gift-card-value');
    if (!isHidden && customInput) {
      customInput.value = '';
      customInput.classList.remove('is-filled');
    }

    // Look up variant by data-option-value (e.g. "10 €" → parseInt → 10)
    var optAmt = parseInt(e.target.getAttribute('data-option-value') || '', 10);
    if (isNaN(optAmt)) return;
    var variant = window.giftCardVariantMap && window.giftCardVariantMap[String(optAmt)];
    if (!variant) {
      console.warn('[GiftCard] no variant in map for preset amount', optAmt);
      return;
    }

    console.log('[GiftCard] preset', optAmt, '€ → id', variant.id);
    applyGiftCardVariant(variant);
  }, true); // true = capture phase

  // Custom amount committed → instant DOM update via variant map (no fetch)
  document.addEventListener('change', function (e) {
    if (!e.target.matches('#variable-gift-card-value')) return;
    var input = e.target;
    var amount = parseInt(input.value, 10);
    if (isNaN(amount) || amount < 1) return;

    var variant = window.giftCardVariantMap && window.giftCardVariantMap[String(amount)];
    if (!variant) {
      console.warn('[GiftCard] no variant for amount', amount, '— check giftCardVariantMap');
      return;
    }

    console.log('[GiftCard] applying variant', amount, '€ → id', variant.id);
    input.classList.add('is-filled');

    // Remove checked state from all preset radios so their labels lose active style
    var container = input.closest('[has-gift-card-fixed-values]');
    if (container) {
      container.querySelectorAll('.block-swatch input[type="radio"]').forEach(function (r) {
        r.checked = false;
      });
    }

    applyGiftCardVariant(variant);
  });
})();


// PDP: Showing or hiding divider from related-products section when recently-viewed-products section exists.
(function () {
  if (!document.body.classList.contains("template-product")) return;

  var mo;
  function sync() {
    if (!document.querySelector(".ed_recently_viewed_products_section")) return;
    var host = document.querySelector(".shopify-section--product-recommendations product-recommendations");
    var divider = document.querySelector(".shopify-section--product-recommendations .ed_product_recommendations__divider");
    if (host) host.classList.add("rvp_available");
    if (divider) divider.classList.add("rvp_available");
    if (host && divider) mo.disconnect();
  }

  mo = new MutationObserver(sync);
  mo.observe(document.body, { childList: true, subtree: true });
  document.addEventListener("shopify:section:load", sync);
  sync();
})();


// PDP: keep in sync with snippets/kavalio-variant-on-sale-pdp.liquid
(function () {
  function getVariantPurchasableMap(form) {
    if (!form) return null;

    var availabilityNode = form.querySelector("script[data-variant-availability-map]");
    if (availabilityNode) {
      try {
        var availabilityMap = JSON.parse(availabilityNode.textContent || "{}");
        var purchasableMap = {};
        Object.keys(availabilityMap).forEach(function (variantId) {
          purchasableMap[variantId] = !!(availabilityMap[variantId] && availabilityMap[variantId].canBuy);
        });
        return purchasableMap;
      } catch (e) {
        return null;
      }
    }

    var node = form.querySelector("script[data-dropshipping-purchasable-map]");
    if (!node) return null;

    try {
      return JSON.parse(node.textContent || "{}");
    } catch (e) {
      return null;
    }
  }

  function getBackInStockEligibleMap(form) {
    if (!form) return null;

    var availabilityNode = form.querySelector("script[data-variant-availability-map]");
    if (availabilityNode) {
      try {
        var availabilityMap = JSON.parse(availabilityNode.textContent || "{}");
        var backInStockMap = {};
        Object.keys(availabilityMap).forEach(function (variantId) {
          backInStockMap[variantId] = !!(
            availabilityMap[variantId] && availabilityMap[variantId].backInStockEligible
          );
        });
        return backInStockMap;
      } catch (e) {
        return null;
      }
    }

    var node = form.querySelector("script[data-back-in-stock-eligible-map]");
    if (!node) return null;

    try {
      return JSON.parse(node.textContent || "{}");
    } catch (e) {
      return null;
    }
  }

  function getPdpProductForm() {
    var picker = document.querySelector("variant-picker");
    var formId = picker && picker.getAttribute("form-id");
    return (
      (formId && (document.getElementById(formId) || document.forms[formId])) ||
      document.querySelector('form[is="product-form"]')
    );
  }

  function isKavalioVariantPurchasable(variant, form) {
    if (!variant || !variant.id) return false;

    if (!form) {
      form = getPdpProductForm();
    }

    var map = getVariantPurchasableMap(form);
    if (map && Object.prototype.hasOwnProperty.call(map, String(variant.id))) {
      return map[String(variant.id)] === true;
    }

    return variant.available !== false;
  }

  function isKavalioVariantBackInStockEligible(variant, form) {
    if (!variant || !variant.id) return false;

    if (!form) {
      form = getPdpProductForm();
    }

    var map = getBackInStockEligibleMap(form);
    if (map && Object.prototype.hasOwnProperty.call(map, String(variant.id))) {
      return map[String(variant.id)] === true;
    }

    return false;
  }

  function isKavalioVariantDiscounted(variant) {
    if (!variant) return false;
    var compareAt = variant.compare_at_price;
    if (compareAt == null || compareAt === "") return false;
    return Number(variant.price) < Number(compareAt);
  }

  function isKavalioVariantOnSale(variant, form) {
    return isKavalioVariantDiscounted(variant);
  }

  function setKavalioSaleBadgeVisible(badge, visible) {
    if (!badge) return;
    badge.classList.toggle("is-hidden", !visible);
    if (visible) {
      badge.removeAttribute("hidden");
    } else {
      badge.setAttribute("hidden", "");
    }
  }

  function updatePdpSaleBadges(variant, form) {
    document.querySelectorAll("[data-kavalio-sale-badge-dynamic]").forEach(function (badge) {
      setKavalioSaleBadgeVisible(badge, isKavalioVariantOnSale(variant, form));
    });
  }

  function getInitialVariantFromPicker() {
    var picker = document.querySelector("variant-picker");
    if (!picker) return null;

    var variantScript = picker.querySelector("script[data-variant]");
    if (!variantScript) return null;

    try {
      return JSON.parse(variantScript.textContent || "{}");
    } catch (e) {
      return null;
    }
  }

  function syncInitialPdpSaleBadges() {
    if (!document.querySelector("[data-kavalio-sale-badge-dynamic]")) return;
    var variant = getInitialVariantFromPicker();
    if (!variant || !variant.id) return;

    var picker = document.querySelector("variant-picker");
    var formId = picker && picker.getAttribute("form-id");
    var form =
      (formId && (document.getElementById(formId) || document.forms[formId])) ||
      getPdpProductForm();

    updatePdpSaleBadges(variant, form);
  }

  function handleVariantChange(event) {
    var variant = event.detail && event.detail.variant;
    if (!variant) return;

    var formId = event.detail && event.detail.formId;
    var form =
      (formId && (document.getElementById(formId) || document.forms[formId])) ||
      (event.target && event.target.tagName === "FORM" ? event.target : null);

    updatePdpSaleBadges(variant, form);
  }

  document.addEventListener("variant:change", handleVariantChange);
  document.addEventListener("variant:changed", handleVariantChange);
  document.addEventListener("shopify:section:load", syncInitialPdpSaleBadges);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", syncInitialPdpSaleBadges);
  } else {
    syncInitialPdpSaleBadges();
  }
})();


// Product media: scroll pagination dots
(function () {
  function getActiveDot(dotsNav, flickity) {
    if (flickity && flickity.selectedElement) {
      var mediaId = flickity.selectedElement.getAttribute("data-media-id");
      if (mediaId) {
        var dotByMedia = dotsNav.querySelector(
          '.dots-nav__item[data-media-id="' + mediaId + '"]:not(.is-filtered)'
        );
        if (dotByMedia) return dotByMedia;
      }
    }

    return dotsNav.querySelector('.dots-nav__item[aria-current="true"]:not(.is-filtered)');
  }

  function syncActiveDotState(mediaNav, flickity) {
    var dotsNav = mediaNav.querySelector(".dots-nav");
    if (!dotsNav || !flickity || !flickity.selectedElement) return;

    var mediaId = flickity.selectedElement.getAttribute("data-media-id");
    if (!mediaId) return;

    dotsNav.querySelectorAll(".dots-nav__item").forEach(function (dot) {
      if (dot.getAttribute("data-media-id") === mediaId && !dot.classList.contains("is-filtered")) {
        dot.setAttribute("aria-current", "true");
      } else {
        dot.removeAttribute("aria-current");
      }
    });
  }

  function scrollActiveDotIntoView(mediaNav, animate, flickity) {
    var dotsNav = mediaNav.querySelector(".dots-nav");
    if (!dotsNav) return;

    syncActiveDotState(mediaNav, flickity);

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        var activeDot = getActiveDot(dotsNav, flickity);
        if (!activeDot) return;

        var containerWidth = dotsNav.clientWidth;
        var maxScroll = dotsNav.scrollWidth - containerWidth;

        if (maxScroll <= 0) {
          dotsNav.scrollLeft = 0;
          return;
        }

        var containerRect = dotsNav.getBoundingClientRect();
        var dotRect = activeDot.getBoundingClientRect();
        var dotCenterInContent =
          dotRect.left - containerRect.left + dotsNav.scrollLeft + dotRect.width / 2;
        var targetScroll = dotCenterInContent - containerWidth / 2;

        targetScroll = Math.max(0, Math.min(targetScroll, maxScroll));

        dotsNav.scrollTo({
          left: targetScroll,
          behavior: animate ? "smooth" : "auto",
        });
      });
    });
  }

  function setupProductMediaNav(mediaNav) {
    if (mediaNav.__dotsNavScrollBound) return;
    mediaNav.__dotsNavScrollBound = true;

    mediaNav.querySelectorAll(".product__media-prev-next").forEach(function (button) {
      button.removeAttribute("disabled");
    });

    var carouselId = mediaNav.getAttribute("controls");
    if (!carouselId) return;

    var carousel = document.getElementById(carouselId);
    if (!carousel) return;

    var scrollDots = function (animate) {
      Promise.resolve(carousel.flickityInstance).then(function (flickity) {
        scrollActiveDotIntoView(mediaNav, animate, flickity);
      });
    };

    var onSlide = function (event) {
      scrollDots(event.type !== "flickity:ready");
    };

    carousel.addEventListener("flickity:ready", onSlide);
    carousel.addEventListener("flickity:slide-changed", onSlide);
    carousel.addEventListener("flickity:slide-settled", function () {
      scrollDots(true);
    });

    var productMedia = carousel.closest("product-media");
    if (productMedia) {
      var formId = productMedia.getAttribute("form-id");
      var form = formId ? document.getElementById(formId) : null;

      if (form) {
        form.addEventListener("variant:change", function () {
          scrollDots(false);
          window.setTimeout(function () {
            scrollDots(false);
          }, 150);
        });
      }
    }
  }

  function init(root) {
    (root || document).querySelectorAll("flickity-controls.product__media-nav").forEach(setupProductMediaNav);
  }

  document.addEventListener("shopify:section:load", function (event) {
    init(event && event.target ? event.target : document);
  });

  document.addEventListener("product:media-rerendered", function (event) {
    init(event && event.target ? event.target : document);
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      init(document);
    });
  } else {
    init(document);
  }
})();
// END: Product media: scroll pagination dots


// Product media: floating image counter
(function () {
  function updateMediaCounter(carousel) {
    var wrapper = carousel.closest(".product__media-list-wrapper");
    if (!wrapper) return;

    var counter = wrapper.querySelector("[data-pdp-media-counter]");
    if (!counter) return;

    var currentEl = counter.querySelector("[data-pdp-media-counter-current]");
    var totalEl = counter.querySelector("[data-pdp-media-counter-total]");
    if (!currentEl || !totalEl) return;

    Promise.resolve(carousel.flickityInstance).then(function (flickity) {
      if (!flickity || flickity.slides.length <= 1) {
        counter.hidden = true;
        return;
      }

      counter.hidden = false;
      currentEl.textContent = flickity.selectedIndex + 1;
      totalEl.textContent = flickity.slides.length;
    });
  }

  function setupMediaCounter(carousel) {
    if (carousel.__mediaCounterBound) {
      updateMediaCounter(carousel);
      return;
    }
    carousel.__mediaCounterBound = true;

    var onUpdate = function () {
      updateMediaCounter(carousel);
    };

    carousel.addEventListener("flickity:ready", onUpdate);
    carousel.addEventListener("flickity:slide-changed", onUpdate);
    carousel.addEventListener("flickity:slide-settled", onUpdate);

    updateMediaCounter(carousel);
  }

  function init(root) {
    (root || document).querySelectorAll("flickity-carousel.product__media-list").forEach(setupMediaCounter);
  }

  document.addEventListener("shopify:section:load", function (event) {
    init(event && event.target ? event.target : document);
  });

  document.addEventListener("product:media-rerendered", function (event) {
    init(event && event.target ? event.target : document);
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      init(document);
    });
  } else {
    init(document);
  }
})();
//END: Product media floating image counter


// START: Forced fixed discount price on variant switch
// The PDP price lives in a server-rerendered block ([data-block-type="price"], see
// snippets/product-form.liquid). Just like the SKU (.product-meta__sku-number in the
// "meta" block), it is replaced on variant switch — but the swapped-in markup shows the
// plain price without the forced discount. We watch the price container (same
// idea as reading variant.sku for the SKU) and rebuild the compare/sale price + badge
// from the current variant's price whenever the block changes or a variant is selected.
// The discount percent comes from data-kavalio-forced-discount, which Liquid sets from
// the product metafield custom.anzeige_rabatt.
(function () {
  var isForced = false;
  var discountPercent = 30;
  var template = null; // {prefix, suffix, decSep, thouSep} captured from a rendered price
  var regularPriceLabelHTML = ""; // visually-hidden a11y label (regular price)
  var salePriceLabelHTML = ""; // visually-hidden a11y label (sale price)
  var savedBadgeHTML = null; // "-30%" discount label markup
  var observer = null;
  var applying = false;
  var rafId = null;

  function detectForced() {
    return !!document.querySelector(".ed-price-list[data-kavalio-forced-discount]");
  }

  function getInner() {
    return document.querySelector(
      ".product-meta__price-list-container .ed-price-list-inner"
    );
  }

  function getVisibleText(el) {
    if (!el) return "";
    var clone = el.cloneNode(true);
    Array.prototype.forEach.call(
      clone.querySelectorAll(".visually-hidden"),
      function (node) {
        node.parentNode.removeChild(node);
      }
    );
    return clone.textContent.replace(/\s+/g, " ").trim();
  }

  // Learn the currency layout (separators, symbol, placement) from a rendered price
  // string such as "1.199,00 €" so we can format arbitrary cent amounts identically.
  function parseTemplate(sampleText) {
    if (!sampleText) return null;
    var match = sampleText.match(/\d[\d.,\u00A0\s]*\d|\d/);
    if (!match) return null;

    var numPart = match[0];
    var start = match.index;
    var decSep = "";
    var decMatch = numPart.match(/([.,])(\d{2})$/);
    if (decMatch) decSep = decMatch[1];

    return {
      prefix: sampleText.slice(0, start),
      suffix: sampleText.slice(start + numPart.length),
      decSep: decSep,
      thouSep: decSep === "," ? "." : decSep === "." ? "," : "",
    };
  }

  function formatCents(cents, tpl) {
    var negative = cents < 0;
    cents = Math.abs(Math.round(cents));
    var whole;
    var frac = "";
    if (tpl.decSep) {
      whole = Math.floor(cents / 100);
      frac = String(cents % 100);
      while (frac.length < 2) frac = "0" + frac;
    } else {
      whole = Math.round(cents / 100);
    }
    var wholeStr = String(whole);
    if (tpl.thouSep) {
      wholeStr = wholeStr.replace(/\B(?=(\d{3})+(?!\d))/g, tpl.thouSep);
    }
    var num = tpl.decSep ? wholeStr + tpl.decSep + frac : wholeStr;
    return tpl.prefix + (negative ? "-" : "") + num + tpl.suffix;
  }

  // The full-price element is the strike-through compare price if present, otherwise the
  // lone (non-discounted) price span. The theme keeps this element's value fresh — via the
  // server rerender for normal variants, or the gift-card value picker for gift cards.
  function readFullPriceEl(inner) {
    var compare = inner.querySelector(".price--compare");
    if (compare) return compare;
    var prices = inner.querySelectorAll(".price");
    for (var i = 0; i < prices.length; i++) {
      if (!prices[i].classList.contains("price--highlight")) return prices[i];
    }
    return null;
  }

  function parseCentsFromText(text) {
    if (!text || !template) return null;
    var match = text.match(/\d[\d.,\u00A0\s]*\d|\d/);
    if (!match) return null;
    var cleaned = match[0].replace(/[\s\u00A0]/g, "");
    if (template.thouSep) cleaned = cleaned.split(template.thouSep).join("");
    if (template.decSep) cleaned = cleaned.replace(template.decSep, ".");
    var value = parseFloat(cleaned);
    return isNaN(value) ? null : Math.round(value * 100);
  }

  function captureConfig() {
    var inner = getInner();
    if (inner) {
      var compare = inner.querySelector(".price--compare");
      var highlight = inner.querySelector(".price--highlight");

      var compareVH = compare && compare.querySelector(".visually-hidden");
      if (compareVH) regularPriceLabelHTML = compareVH.outerHTML;

      var highlightVH = highlight && highlight.querySelector(".visually-hidden");
      if (highlightVH) salePriceLabelHTML = highlightVH.outerHTML;

      if (!template) {
        template = parseTemplate(
          getVisibleText(compare || inner.querySelector(".price"))
        );
      }

      var badge = inner.querySelector(
        ".product-meta__label-list .label--highlight"
      );
      if (badge) savedBadgeHTML = badge.outerHTML;
    }

    var marker = document.querySelector(
      ".ed-price-list[data-kavalio-forced-discount]"
    );
    if (marker) {
      var pct = parseFloat(marker.getAttribute("data-kavalio-forced-discount"));
      if (!isNaN(pct)) discountPercent = pct;
    }
  }

  function apply() {
    if (!isForced || applying) return;

    var inner = getInner();
    if (!inner) return;

    if (!template) {
      template = parseTemplate(getVisibleText(inner.querySelector(".price")));
    }
    if (!template) return;

    var compare = inner.querySelector(".price--compare");
    var highlight = inner.querySelector(".price--highlight");
    var fullEl = readFullPriceEl(inner);
    if (!fullEl) return;

    // Derive the full price from what is actually shown (kept fresh by the theme), so the
    // reduced price always follows — including the gift-card value picker, which only
    // updates the (first) compare price and never fires a variant:change event.
    var fullCents = parseCentsFromText(getVisibleText(fullEl));
    if (fullCents == null) return;

    var saleCents = Math.round((fullCents * (100 - discountPercent)) / 100);

    // Skip when the DOM already reflects the correct discount (avoids observer loop).
    if (
      compare &&
      highlight &&
      parseCentsFromText(getVisibleText(compare)) === fullCents &&
      parseCentsFromText(getVisibleText(highlight)) === saleCents
    ) {
      return;
    }

    var fullVH =
      (compare && compare.querySelector(".visually-hidden")
        ? compare.querySelector(".visually-hidden").outerHTML
        : "") ||
      regularPriceLabelHTML ||
      (fullEl.querySelector(".visually-hidden")
        ? fullEl.querySelector(".visually-hidden").outerHTML
        : "");
    var saleVH =
      (highlight && highlight.querySelector(".visually-hidden")
        ? highlight.querySelector(".visually-hidden").outerHTML
        : "") ||
      salePriceLabelHTML ||
      fullVH;

    applying = true;
    try {
      Array.prototype.slice.call(inner.children).forEach(function (child) {
        if (child.classList && child.classList.contains("price")) {
          inner.removeChild(child);
        }
      });

      inner.insertAdjacentHTML(
        "afterbegin",
        '<span class="price price--compare">' +
          fullVH +
          formatCents(fullCents, template) +
          "</span>" +
          '<span class="price price--highlight price--large">' +
          saleVH +
          formatCents(saleCents, template) +
          "</span>"
      );

      if (savedBadgeHTML) {
        var labelList = inner.querySelector(".product-meta__label-list");
        if (!labelList) {
          labelList = document.createElement("div");
          labelList.className = "product-meta__label-list label-list";
          inner.appendChild(labelList);
        }
        if (!labelList.querySelector(".label--highlight")) {
          labelList.insertAdjacentHTML("beforeend", savedBadgeHTML);
        }
      }
    } finally {
      applying = false;
    }
  }

  function scheduleApply() {
    if (rafId) window.cancelAnimationFrame(rafId);
    rafId = window.requestAnimationFrame(function () {
      rafId = null;
      apply();
    });
  }

  function observePrice() {
    var container = document.querySelector(".product-meta__price-list-container");
    if (!container) return;
    if (observer) observer.disconnect();
    observer = new MutationObserver(function () {
      if (applying) return;
      scheduleApply();
    });
    observer.observe(container, { childList: true, subtree: true });
  }

  function init() {
    isForced = detectForced();
    if (!isForced) return;

    captureConfig();
    apply();
    observePrice();

    document.addEventListener("variant:change", scheduleApply);
    document.addEventListener("variant:changed", scheduleApply);
    document.addEventListener("shopify:section:load", function () {
      captureConfig();
      observePrice();
      scheduleApply();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
// END: Forced fixed discount price on variant switch